import { HugeiconsIcon } from "@hugeicons/react";
import { EqualSignIcon, User02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Card } from "shared/components/Card";
import { Show } from "shared/components";

const RULES = [
  {
    icon: User02Icon,
    step: 1,
    title: "Only one agent available at the requested time?",
    description: "Showing goes to that agent automatically."
  },
  {
    icon: EqualSignIcon,
    step: 2,
    title: "Workload is equal?",
    description:
      "System assigns to the next agent in the rotation to the right."
  }
];

export const AssignmentRules = () => {
  return (
    <Card>
      <h3 className="px-4 md:px-8 py-4 md:py-6 text-base font-bold text-content-1000 border-b border-alpha-40">
        How are showings assigned?
      </h3>

      <div className="mt-6 md:mt-8 px-4 md:px-8 pb-6 md:pb-8 flex flex-col">
        {RULES.map((rule, idx) => (
          <div key={rule.step} className="flex">
            <div className="relative flex flex-col items-center">
              <Show if={idx === 0}>
                <div className="absolute bottom-full mb-2 h-[24px] border-l border-dashed border-content-100" />
              </Show>

              <div className="relative flex size-10 shrink-0 items-center justify-center rounded-full bg-background-900">
                <HugeiconsIcon
                  icon={rule.icon}
                  size={20}
                  strokeWidth={1.5}
                  className="text-content-1000"
                />
                <span className="absolute -bottom-1 -right-1 flex size-4 items-center justify-center rounded-full bg-background-800 text-xxs font-bold text-content-1000 border border-white">
                  {rule.step}
                </span>
              </div>
              <Show if={idx < RULES.length - 1}>
                <div className="absolute top-12 bottom-[48px] min-h-[24px] border-l border-dashed border-content-100" />
              </Show>
            </div>

            <div className="flex-1 pl-6 min-h-[80px]">
              <p className="text-sm font-bold text-content-1000">
                {rule.title}
              </p>
              <p className="mt-2 text-sm text-content-400">
                {rule.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};
